/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AddUserDto { 
    /**
     * Nome
     */
    firstname: string;
    /**
     * Cognome
     */
    lastname: string;
    /**
     * Email
     */
    email: string;
    /**
     * Telefono
     */
    phone: string;
    /**
     * Ruoli
     */
    role: AddUserDto.RoleEnum;
    /**
     * Aziende
     */
    companies: Array<string>;
}
export namespace AddUserDto {
    export const RoleEnum = {
        Hr: 'HR',
        Admin: 'ADMIN',
        Technician: 'TECHNICIAN'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


